var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsuranceD4940Cd803(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.07 6.09L16.26 2.3a2.83 2.83 0 0 0-2.52 0h0l-7.86 4a2.8 2.8 0 0 0-1.55 2.54v7.05a9.1 9.1 0 0 0 4 7.51l4.87 4a2.85 2.85 0 0 0 1.8.6 2.82 2.82 0 0 0 1.79-.62l4.84-3.91a9.27 9.27 0 0 0 4-7.53v-7.3a2.85 2.85 0 0 0-1.56-2.55zm.13 9.83a7.75 7.75 0 0 1-3.46 6.35l-4.88 3.94a1.38 1.38 0 0 1-1.72 0l-4.92-4a7.71 7.71 0 0 1-3.42-6.32v-7a1.37 1.37 0 0 1 .75-1.22l7.86-4h0a1.31 1.31 0 0 1 .59-.18 1.41 1.41 0 0 1 .6.13l7.81 3.79a1.39 1.39 0 0 1 .77 1.23zm-5.6-1.64h-2.88V11.4a.72.72 0 1 0-1.44 0v2.88H11.4a.72.72 0 1 0 0 1.44h2.88v2.88a.72.72 0 1 0 1.44 0v-2.88h2.88a.72.72 0 0 0 0-1.44z",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 5.4,
    r: 2.1,
    fill: "#ffc700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsuranceD4940Cd803);
export default __webpack_public_path__ + "static/media/icon_insurance_d4940cd803.11f8b81efe7c6c190860a64d6c7c58d5.svg";
export { ForwardRef as ReactComponent };